var rich_content_viewer_default = {
  "fontElementMap": "gELBO",
  "wrapper": "_7mUMj",
  "pluginContainerMobile": "UPGxR",
  "viewer": "cdIeK",
  "android": "CdsJX",
  "rootedTraversedContent": "eK0IZ",
  "atomic": "xr00X",
  "toolbar": "je4CN",
  "block": "A7KAU"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
